<template>
	<div class="shitiLzBox">
		<div class="shitiLzST" v-for="(it, index) in perData" :key="index">
			<div class="shitiLzTit">
				<div class="shitiLzTip">【试题编号】</div>
				<div class="shitiLzTitCon">
					{{ it.number }}
				</div>
				<div class="shitiLzTitJs">—— {{ it.source }}</div>
			</div>
			<div class="shitiLzYw">
				<div class="shitiLzTip">【录音原文】</div>
				<div class="shitiLzYwCont" v-html="it.originalContent"></div>
			</div>
			<div class="shitiLzBtns">
				<div class="shitiLzTip"></div>
				<!-- <div class="shitiLzBtn supHove3" @click="jtBtns(it)">
                <img src="@/assets/img/形状.png" alt="">
                <span>精听</span>
            </div> -->
				<jting-button @btns="jtBtns(it)" @qkFn="qkFn" :ref="'jting'" types="zb" />
				<div class="shitiLzBtn shitiLzBtn1">
					词数
					<span>{{ it.wordsNumber }}</span>
				</div>
			</div>
			<div class="shitiLzTm" v-for="(i, s) in it.yydSmallQuestionList" :key="s">
				<div class="shitiLzWd">
					<div class="shitiLzTip">【试题问答】</div>
					<div class="shitiLzTim">
						<h2>{{ i.title }}</h2>
						<p v-for="(a, b) in i.yydSmallQuestionOptionList" :key="b">{{ a.number }}、{{ a.content }}</p>
					</div>
				</div>
				<div class="shitiLzDa">
					<div class="shitiLzTip">【正确答案】</div>
					<div class="shitiLzXs">
						<div class="shitiLzItem" v-for="item in 'ABCDEFG'.substring(0, i.yydSmallQuestionOptionList.length)" :key="item">
							<el-checkbox v-prevent-click :value="item == i.answer">{{ item }}</el-checkbox>
						</div>
					</div>
				</div>
			</div>
			<div class="shitiLzFot">
				<div class="cBox" :style="{ width: (it.topicName.length + it.testCenterName.length) * 2 * 16 + 600 + 'px' }">
					<span style="width: 185px">本题情景录音的主要内容是：</span>
					<div>
						<p>{{ it.topicName }}</p>
					</div>
					<span class="spd" style="width: 115px">涉及到的考点是：</span>
					<div>
						<p>{{ it.testCenterName }}</p>
					</div>
					<!-- 添加一个重复的副本 -->
					<span style="width: 185px; margin-left: 40px">本题情景录音的主要内容是：</span>
					<div>
						<p>{{ it.topicName }}</p>
					</div>
					<span class="spd" style="width: 115px">涉及到的考点是：</span>
					<div>
						<p>{{ it.testCenterName }}</p>
					</div>
				</div>
			</div>
			<div class="shitiLzDel supHove3" v-if="!type" @click="delBtn(it)">
				{{ it.delFlag ? '已移除' : '移除试题蓝' }}
			</div>
			<div class="shitiLzDel shitiLzDel1 supHove3" :class="{ shitiLzDelhs: it.isAddBasket }" @click="addBtn(it)" v-if="type == 2">
				<i class="el-icon-plus" v-if="!it.isAddBasket"></i>
				{{ it.isAddBasket ? '已' : '' }}加入试题篮
			</div>
			<div class="shitiLzDel shitiLzDel1 supHove3" v-if="type == 3" @click="xzBtn(it)">
				<i class="el-icon-plus"></i>
				选择试题
			</div>
			<div class="shitiLzGding">
				<div class="shitiLzGdingT">
					{{ it.difficultyScore }}
				</div>
				<div class="shitiLzGdingB">难易度</div>
			</div>
		</div>
		<div v-if="perData.length == 0" style="background: #ffffff; border-radius: 0px 0px 6px 6px; padding: 0 15px; height: 450px">
			<el-empty description="暂无试题~"></el-empty>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'shitiLz',
	data() {
		return {
			delFlag: false,
			qrType: 1
		};
	},
	props: {
		type: {
			type: String,
			default: ''
		},
		perData: {
			type: Array,
			default: []
		},
		stStand: {
			type: Object,
			default: function () {
				return {};
			}
		}
	},
	components: {},
	methods: {
		animFn(len) {
			console.log('scrollText ' + len + 's linear infinite');
			return 'scrollText ' + len + 's linear infinite';
		},
		qkFn() {
			console.log(this.$refs['jting'].length, 9999);
			if (this.$refs['jting'].length) {
				this.$refs['jting'].forEach((item) => {
					item.btnFlag = false;
					item.bfFlag = true;
				});
			} else {
				this.$refs['jting'].btnFlag = false;
				this.$refs['jting'].bfFlag = true;
			}
		},
		jtBtns(item) {
			console.log(item.recordingFileId, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.recordingFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.$audio.init(URL.createObjectURL(blob), (r) => {});
								this.$nextTick((r) => {
									this.$audio.play();
								});
							}
						});
					}
				});
		},
		xzBtn(it) {
			let str = this.stStand?.num + this.stStand?.type;
			console.log(it.number.substring(it.number.length - 2, it.number.length), 222);
			if (str != it.number.substring(it.number.length - 2, it.number.length)) {
				this.$message({
					type: 'warning',
					message: `请选择${str}类型的题目`
				});
				return;
			}
			let data = {
				...this.stStand,
				stdec: it
			};
			this.$store.commit('dicTemTest', data);

			if (this.qrType == 2) {
				this.$router.replace({
					path: 'tihuanKt',
					query: {
						tjStatus: 1,
						txt: '试题确认'
					}
				});
			} else {
				this.$router.replace({
					path: 'xuanzMb',
					query: {
						tjStatus: 1,
						txt: '选择模板'
					}
				});
			}
			console.log(data, 77777);
		},
		addBtn(it) {
			if (it.isAddBasket) {
				return;
			}
			let set = this.$loading(this.$pre);
			this.$http.post(`api/app/yydQuestionBasket/add/${it.examinationQuestionId}`).then((res) => {
				set.close();
				if (res.code == 200) {
					this.$message({
						type: 'success',
						message: '添加成功'
					});
					this.$set(it, 'isAddBasket', 1);
					this.$emit('lzFn');
				}
			});
		},
		delBtn(it) {
			console.log(it);
			if (it.delFlag) {
				this.$message({
					type: 'warning',
					message: '已移除'
				});
				return;
			}
			it.delFlag = false;
			this.$confirm(`是否移除试题编号为${it.number}的题目?`, '提示', {
				confirmButtonText: '确认',
				confirmButtonClass: 'delBtns',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.delete(`api/app/yydQuestionBasket/${it.examinationQuestionId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '移除成功'
							});
							it.delFlag = true;
							this.$emit('lzFn', it);
						}
					});
				})
				.catch(() => {});
		}
	},
	activated() {
		let { qrType } = this.$route.query;
		this.qrType = qrType || 1;
	}
};
</script>
<style lang="scss" scoped>
.shitiLzBox {
	flex: 1;
	margin-left: 10px;
	.shitiLzST {
		background: #fff;
		padding: 15px 20px 19px 15px;
		position: relative;
		margin-bottom: 10px;
		.shitiLzTip {
			width: 72px;
			margin-right: 7px;
			color: #b8b8b8;
			font-size: 12px;
		}
		.shitiLzFot {
			margin-top: 19px;
			height: 34px;
			color: #0d0d0d;
			font-size: 14px;
			padding: 0 9px;
			background: #e8f1eb;
			border-radius: 2px;
			overflow: hidden;
			width: 780px;
			box-sizing: border-box;
			span {
				color: #1d7b3a;
			}
			.spd {
				margin-left: 10px;
			}
		}
		.shitiLzDel {
			width: 78px;
			height: 30px;
			background: #ffffff;
			box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
			border: 1px solid #d8e0f0;
			font-size: 12px;
			color: #000000;
			border-radius: 4px;
			box-sizing: border-box;
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			position: absolute;
			right: 20px;
			bottom: 63px;
		}
		.shitiLzDel1 {
			width: 92px;
			height: 30px;
			background: #1d7b3a;
			border: 1px solid #14652d;
			font-size: 12px;
			color: #ffffff;
			line-height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			i {
				margin-right: 2px;
			}
		}
		.shitiLzDelhs {
			opacity: 0.6;
			cursor: no-drop;
		}
		.shitiLzGding {
			width: 68px;
			background: #ffffff;
			box-sizing: border-box;
			position: absolute;
			top: 20px;
			right: 20px;
			.shitiLzGdingT {
				height: 39px;
				font-weight: bold;
				font-size: 24px;
				color: #1d7b3a;
				border-radius: 10px 10px 0px 0px;
				border: 2px solid #1d7b3a;
				font-size: 24px;
				text-align: center;
				line-height: 39px;
				box-sizing: border-box;
			}
			.shitiLzGdingB {
				height: 32px;
				background: #1d7b3a;
				border-radius: 0px 0px 10px 10px;
				border: 2px solid #1d7b3a;
				color: #fff;
				font-size: 17px;
				text-align: center;
				line-height: 26px;
				box-sizing: border-box;
			}
		}
		.shitiLzTm {
			margin-bottom: 25px;
			.shitiLzDa {
				display: flex;
				align-items: center;
				.shitiLzXs {
					display: flex;
					align-items: center;
					.shitiLzItem {
						margin-right: 22px;
					}
				}
			}
			.shitiLzWd {
				display: flex;
				font-size: 12px;
				margin-bottom: 6px;
				.shitiLzTim {
					h2 {
						margin-bottom: 6px;
						color: #000000;
						font-weight: bold;
					}
					p {
						line-height: 2;
					}
				}
			}
			&:last-of-type {
				margin-bottom: 0;
			}
		}
		.shitiLzBtns {
			margin-bottom: 18px;
			display: flex;
			.shitiLzBtn {
				width: 63px;
				height: 26px;
				background: #1d7b3a;
				border-radius: 4px;
				display: flex;
				align-items: center;
				color: #fff;
				justify-content: center;
				font-size: 14px;
				cursor: pointer;
				margin-left: 10px;
				box-sizing: border-box;
				img {
					width: 16px;
					height: 14px;
					margin-right: 6px;
				}
			}
			.shitiLzBtn1 {
				background: #ffffff;
				border: 1px solid #1d7b3a;
				color: #1d7b3a;
				width: 72px;
				span {
					margin-left: 8px;
				}
			}
		}
		.shitiLzYw {
			display: flex;
			margin-bottom: 14px;
			font-size: 12px;
			color: #000000;
			line-height: 17px;
			.shitiLzYwCont {
				flex: 1;
				padding-right: 80px;
			}
		}
		.shitiLzTit {
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			font-size: 12px;
			color: #000000;
			.shitiLzTitJs {
				color: #b8b8b8;
				margin-left: 18px;
			}
		}
	}
}
.shitiLzFot .cBox {
	display: flex;
	align-items: center;
	white-space: nowrap;
	animation: scrollText 18s linear infinite;
	height: 100%;
	overflow: hidden;
}

@keyframes scrollText {
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(-50%);
	}
}
</style>
